/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Pizza Checker API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  PostAggregateOrdersBody,
  PostGetAllOrdersBody,
  PostGetNextOrderBody,
  PostGetPrevOrderBody,
  PostOrdersCountBody,
} from ".././schemas";

import { customInstance } from "../../axios-instance";
import type { ErrorType, BodyType } from "../../axios-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const postGetAllOrders = (
  postGetAllOrdersBody: BodyType<PostGetAllOrdersBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/orders/`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetAllOrdersBody,
      signal,
    },
    options,
  );
};

export const getPostGetAllOrdersQueryKey = (
  postGetAllOrdersBody: PostGetAllOrdersBody,
) => {
  return [`/api/admin/orders/`, postGetAllOrdersBody] as const;
};

export const getPostGetAllOrdersQueryOptions = <
  TData = Awaited<ReturnType<typeof postGetAllOrders>>,
  TError = ErrorType<unknown>,
>(
  postGetAllOrdersBody: PostGetAllOrdersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getPostGetAllOrdersQueryKey(postGetAllOrdersBody);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof postGetAllOrders>>
  > = ({ signal }) =>
    postGetAllOrders(postGetAllOrdersBody, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof postGetAllOrders>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PostGetAllOrdersQueryResult = NonNullable<
  Awaited<ReturnType<typeof postGetAllOrders>>
>;
export type PostGetAllOrdersQueryError = ErrorType<unknown>;

export function usePostGetAllOrders<
  TData = Awaited<ReturnType<typeof postGetAllOrders>>,
  TError = ErrorType<unknown>,
>(
  postGetAllOrdersBody: PostGetAllOrdersBody,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetAllOrders>>,
          TError,
          Awaited<ReturnType<typeof postGetAllOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetAllOrders<
  TData = Awaited<ReturnType<typeof postGetAllOrders>>,
  TError = ErrorType<unknown>,
>(
  postGetAllOrdersBody: PostGetAllOrdersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllOrders>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof postGetAllOrders>>,
          TError,
          Awaited<ReturnType<typeof postGetAllOrders>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function usePostGetAllOrders<
  TData = Awaited<ReturnType<typeof postGetAllOrders>>,
  TError = ErrorType<unknown>,
>(
  postGetAllOrdersBody: PostGetAllOrdersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function usePostGetAllOrders<
  TData = Awaited<ReturnType<typeof postGetAllOrders>>,
  TError = ErrorType<unknown>,
>(
  postGetAllOrdersBody: PostGetAllOrdersBody,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof postGetAllOrders>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getPostGetAllOrdersQueryOptions(
    postGetAllOrdersBody,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const postAggregateOrders = (
  postAggregateOrdersBody: BodyType<PostAggregateOrdersBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/orders/aggregate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postAggregateOrdersBody,
      signal,
    },
    options,
  );
};

export const getPostAggregateOrdersMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAggregateOrders>>,
    TError,
    { data: BodyType<PostAggregateOrdersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAggregateOrders>>,
  TError,
  { data: BodyType<PostAggregateOrdersBody> },
  TContext
> => {
  const mutationKey = ["postAggregateOrders"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAggregateOrders>>,
    { data: BodyType<PostAggregateOrdersBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postAggregateOrders(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAggregateOrdersMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAggregateOrders>>
>;
export type PostAggregateOrdersMutationBody = BodyType<PostAggregateOrdersBody>;
export type PostAggregateOrdersMutationError = ErrorType<unknown>;

export const usePostAggregateOrders = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postAggregateOrders>>,
      TError,
      { data: BodyType<PostAggregateOrdersBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postAggregateOrders>>,
  TError,
  { data: BodyType<PostAggregateOrdersBody> },
  TContext
> => {
  const mutationOptions = getPostAggregateOrdersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postOrdersCount = (
  postOrdersCountBody: BodyType<PostOrdersCountBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/orders/count`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postOrdersCountBody,
      signal,
    },
    options,
  );
};

export const getPostOrdersCountMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postOrdersCount>>,
    TError,
    { data: BodyType<PostOrdersCountBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postOrdersCount>>,
  TError,
  { data: BodyType<PostOrdersCountBody> },
  TContext
> => {
  const mutationKey = ["postOrdersCount"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postOrdersCount>>,
    { data: BodyType<PostOrdersCountBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postOrdersCount(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostOrdersCountMutationResult = NonNullable<
  Awaited<ReturnType<typeof postOrdersCount>>
>;
export type PostOrdersCountMutationBody = BodyType<PostOrdersCountBody>;
export type PostOrdersCountMutationError = ErrorType<unknown>;

export const usePostOrdersCount = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postOrdersCount>>,
      TError,
      { data: BodyType<PostOrdersCountBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postOrdersCount>>,
  TError,
  { data: BodyType<PostOrdersCountBody> },
  TContext
> => {
  const mutationOptions = getPostOrdersCountMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postGetNextOrder = (
  postGetNextOrderBody: BodyType<PostGetNextOrderBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/orders/next`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetNextOrderBody,
      signal,
    },
    options,
  );
};

export const getPostGetNextOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGetNextOrder>>,
    TError,
    { data: BodyType<PostGetNextOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGetNextOrder>>,
  TError,
  { data: BodyType<PostGetNextOrderBody> },
  TContext
> => {
  const mutationKey = ["postGetNextOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGetNextOrder>>,
    { data: BodyType<PostGetNextOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postGetNextOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostGetNextOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGetNextOrder>>
>;
export type PostGetNextOrderMutationBody = BodyType<PostGetNextOrderBody>;
export type PostGetNextOrderMutationError = ErrorType<unknown>;

export const usePostGetNextOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGetNextOrder>>,
      TError,
      { data: BodyType<PostGetNextOrderBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGetNextOrder>>,
  TError,
  { data: BodyType<PostGetNextOrderBody> },
  TContext
> => {
  const mutationOptions = getPostGetNextOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const postGetPrevOrder = (
  postGetPrevOrderBody: BodyType<PostGetPrevOrderBody>,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    {
      url: `/api/admin/orders/prev`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: postGetPrevOrderBody,
      signal,
    },
    options,
  );
};

export const getPostGetPrevOrderMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postGetPrevOrder>>,
    TError,
    { data: BodyType<PostGetPrevOrderBody> },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postGetPrevOrder>>,
  TError,
  { data: BodyType<PostGetPrevOrderBody> },
  TContext
> => {
  const mutationKey = ["postGetPrevOrder"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postGetPrevOrder>>,
    { data: BodyType<PostGetPrevOrderBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postGetPrevOrder(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostGetPrevOrderMutationResult = NonNullable<
  Awaited<ReturnType<typeof postGetPrevOrder>>
>;
export type PostGetPrevOrderMutationBody = BodyType<PostGetPrevOrderBody>;
export type PostGetPrevOrderMutationError = ErrorType<unknown>;

export const usePostGetPrevOrder = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postGetPrevOrder>>,
      TError,
      { data: BodyType<PostGetPrevOrderBody> },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postGetPrevOrder>>,
  TError,
  { data: BodyType<PostGetPrevOrderBody> },
  TContext
> => {
  const mutationOptions = getPostGetPrevOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
export const getOrderById = (
  orderId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal,
) => {
  return customInstance<unknown>(
    { url: `/api/admin/orders/${orderId}`, method: "GET", signal },
    options,
  );
};

export const getGetOrderByIdQueryKey = (orderId: string) => {
  return [`/api/admin/orders/${orderId}`] as const;
};

export const getGetOrderByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getOrderById>>,
  TError = ErrorType<unknown>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetOrderByIdQueryKey(orderId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrderById>>> = ({
    signal,
  }) => getOrderById(orderId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!orderId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getOrderById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetOrderByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getOrderById>>
>;
export type GetOrderByIdQueryError = ErrorType<unknown>;

export function useGetOrderById<
  TData = Awaited<ReturnType<typeof getOrderById>>,
  TError = ErrorType<unknown>,
>(
  orderId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderById>>,
          TError,
          Awaited<ReturnType<typeof getOrderById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrderById<
  TData = Awaited<ReturnType<typeof getOrderById>>,
  TError = ErrorType<unknown>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrderById>>,
          TError,
          Awaited<ReturnType<typeof getOrderById>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetOrderById<
  TData = Awaited<ReturnType<typeof getOrderById>>,
  TError = ErrorType<unknown>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};

export function useGetOrderById<
  TData = Awaited<ReturnType<typeof getOrderById>>,
  TError = ErrorType<unknown>,
>(
  orderId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getOrderById>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetOrderByIdQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}
